<!-- Language Selector -->
<div class="lang-selector">
  <p-select [options]="languages" [(ngModel)]="selectedLanguage" optionLabel="name" optionValue="value" (onChange)="onLanguageChange($event)">
    <ng-template let-language pTemplate="item">
      <span>{{ language.name }}</span>
    </ng-template>
  </p-select>
</div>

<!-- Form Heading -->
<div class="form-heading">
  <h2 class="form-title">{{ title | translate }}</h2>
  <p class="form-subtitle">{{ 'AUTH.LOGIN.SUBTITLE' | translate }}</p>
</div>

<!-- Org Badge -->
@if (isOrgLogin && clientId) {
  <div class="org-badge">
    <i class="pi pi-building"></i>
    <span>{{ orgName || (clientId | titlecase) }}</span>
  </div>
}

<form [formGroup]="form" (ngSubmit)="onSubmit($event)">
  <section aria-label="Login form">
    <!-- Account Lockout Warning -->
    @if (isAccountLocked) {
      <div class="lockout-warning">
        <div class="lockout-icon"><i class="pi pi-lock"></i></div>
        <div class="lockout-content">
          <h4 class="lockout-title">{{ 'AUTH.ERRORS.ACCOUNT_LOCKED.TITLE' | translate }}</h4>
          <p class="lockout-message">{{ 'AUTH.ERRORS.ACCOUNT_LOCKED.MESSAGE' | translate }}</p>
        </div>
      </div>
    }

    <!-- Email / Username -->
    <div class="input-field">
      <label for="email" class="field-label">{{ 'AUTH.FIELDS.EMAIL_USERNAME' | translate }}</label>
      <div class="input-group">
        <i class="pi pi-user field-icon"></i>
        <input type="text" [placeholder]="'AUTH.FIELDS.EMAIL_USERNAME' | translate" id="email" pInputText formControlName="email" name="email" required class="field-input" />
      </div>
    </div>

    <!-- Password -->
    <div class="input-field">
      <label for="password" class="field-label">{{ 'AUTH.FIELDS.PASSWORD' | translate }}</label>
      <div class="input-group">
        <i class="pi pi-lock field-icon"></i>
        <p-password
          [placeholder]="'AUTH.FIELDS.PASSWORD' | translate"
          name="password"
          id="password"
          [feedback]="false"
          [toggleMask]="true"
          styleClass="field-password-wrap"
          required
          formControlName="password"
        ></p-password>
      </div>
    </div>
  </section>

  <!-- Forgot Password -->
  <div class="forgot-row">
    @if (!isOrgLogin) {
      <a [routerLink]="['../', 'reset-password']" class="forgot-link">
        {{ 'AUTH.LOGIN.FORGOT_PASS' | translate }} <strong>{{ 'AUTH.LOGIN.RESET_NOW' | translate }}</strong>
      </a>
    }
    @if (isOrgLogin) {
      <a [routerLink]="['/org', clientId, 'auth', 'reset-password']" class="forgot-link">
        {{ 'AUTH.LOGIN.FORGOT_PASS' | translate }} <strong>{{ 'AUTH.LOGIN.RESET_NOW' | translate }}</strong>
      </a>
    }
  </div>

  <!-- Actions -->
  <div class="form-actions">
    <button type="submit" class="btn btn-primary lg submit-btn" [disabled]="isAccountLocked">
      <span>{{ 'AUTH.LOGIN.BUTTON_TEXT' | translate }}</span>
      <i class="pi btn-arrow" [class.pi-arrow-right]="!isRtl" [class.pi-arrow-left]="isRtl"></i>
    </button>

    @if (isOrgLogin && clientHasSAML) {
      <button type="button" (click)="loginWithSAML()" class="btn-sso" [disabled]="isAccountLocked">
        <i class="pi pi-lock"></i>
        <span>{{ 'AUTH.BUTTONS.LOGIN_WITH_SSO' | translate }}</span>
      </button>
    }

    @if (!isOrgLogin) {
      <p class="org-login-prompt">
        <a class="org-login-link" (click)="openOrgFinder()" (keydown.enter)="openOrgFinder()" tabindex="0" role="button">{{ 'AUTH.LOGIN.ORG_LOGIN' | translate }}</a>
      </p>
    }
  </div>
</form>

<!-- Keyera Web shortcut — pass holders don't need a C-Portal account -->
@if (keyeraWebUrl) {
  <div class="keyera-web-card">
    <i class="pi pi-qrcode keyera-web-icon"></i>
    <div class="keyera-web-text">
      <span class="keyera-web-title">{{ 'AUTH.KEYERA_WEB.TITLE' | translate }}</span>
      <span class="keyera-web-desc">{{ 'AUTH.KEYERA_WEB.DESCRIPTION' | translate }}</span>
    </div>
    <a class="keyera-web-link" [href]="keyeraWebUrl" target="_blank" rel="noopener">
      <span>{{ 'AUTH.KEYERA_WEB.OPEN' | translate }}</span>
      <i class="pi pi-external-link"></i>
    </a>
  </div>
}

<!-- Organization Finder Modal -->
<app-org-finder #orgFinderModal></app-org-finder>
